/**
 * Just some handy custom hooks that use other hooks to resolve other things.
 */

import { useMemo } from "react";
import { useCourseDropdown } from "../query/hooks/QueryHooksCourseAdministration";
import { enhanceCourseDropdownWithIntakes } from "../utils/intakeOptions";


/**
 * Retrieves the course dropdown and transforms it into the UI-friendly format.
 * Uses the cached raw dropdown from useCourseDropdown and memoizes the
 * transformation to avoid unnecessary recalculations.
 * @param {object} filters API filters passed directly to GetCouresListDropdownCancelToken.
 * @returns {DefinedUseQueryResult} React Query result with enhanced dropdown data.
 */
export function useCourseDropdownEnhanced(filters) {
    const query = useCourseDropdown(filters);
    
    const enhancedData = useMemo(() => {
        return enhanceCourseDropdownWithIntakes(query.data);
    }, [query.data]);

    return {
        ...query,
        data: enhancedData
    };
}
